module.exports = __webpack_public_path__ + "img/logo-default.728622e.png";